import React from 'react';

import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

import { App } from './App';
import LoaderComponent from './components/LoaderComponent/LoaderComponent';
import { LoaderProvider } from './context/LoaderContext';

import './index.css';
import { AuthProvider } from './context';
import { CartProvider } from './context/CartContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LoaderProvider>
        <CartProvider>
          <AuthProvider>
            <LoaderComponent />
            <ToastContainer
              position='top-right'
              autoClose={5000}
              hideProgressBar
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable={false}
              pauseOnHover={false}
            />
            <App />
          </AuthProvider>
        </CartProvider>
      </LoaderProvider>
    </BrowserRouter>
  </React.StrictMode>
);